/**
 * @param preferenceCenter {HTMLElement}
 * @param onChange {() => void}
 * @return {void}
 */
module.exports = function listenToAnyPreferenceCenterOptionChange(preferenceCenter, onChange) {
    preferenceCenter.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        if (
            checkbox instanceof HTMLInputElement &&
            checkbox.name !== "unsubscribeAll" &&
            checkbox.name !== "subscribeAll" &&
            checkbox.name !== "marketingConsent"
        ) {
            checkbox.addEventListener("change", () => {
                onChange();
            });
        }
    });
}
